import React, { useEffect, useState } from 'react';
import '../../Coporate-travel-management/CorporateBanner/CorporateBanner.css';
import BannerWrapper from '../../../commonComponents/BannerWrapper';

const UniversityTravelBanner = ({onLoad}) => {
     

    return (
        <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div
            className="container-fluid ctm-banner position-relative p-0"
            style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
          >
        <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/University%20travel.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={useHighRes ? handleImageLoad : undefined}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
           {imageLoaded && (
            <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
                <p className="fs4 text-uppercase busy grotesk-headings">UNIVERSITY TRAVEL</p>
                <h1 className="banner-headings w-100">Empowering Your <br /> Educational Journeys</h1>
                <div className="d-flex common-second-content">
                    <div className="ornge-border"></div>
                    <div className="second-content">
                        How far would you go to pursue your academic dreams? We help you guide university tours and seamless travel management, all crafted to support your educational goals with ease.
                    </div>
                </div>
            </div>
        )}
        </div>
      )}
    </BannerWrapper>
    );
};

export default UniversityTravelBanner;
